import { useNavigate } from "react-router-dom";
import "../../styles/sidebar_styles/RootUserSideBar.css";
import { useContext, useEffect, useRef } from "react";
import { AppContext } from "../AppProvider";

const RootUserSideBar = () =>{
    const {
        showSideBar,setShowSideBar,
        mobileSideBarLauncherRef
    } = useContext(AppContext);
    const rootUserSideBarRef = useRef(null);
    const navigate = useNavigate();
    const handleRootUserSideBarClick = (e) =>{
        if(mobileSideBarLauncherRef.current && !mobileSideBarLauncherRef.current.contains(e.target) &&
            rootUserSideBarRef.current && !rootUserSideBarRef.current.classList.contains('hidden')){
            setShowSideBar(false);
        }
    };
    useEffect(() =>{
        document.addEventListener('click',handleRootUserSideBarClick);
        return () =>{
            document.removeEventListener('click',handleRootUserSideBarClick);
        }
    },[]);
    useEffect(() => {
        if(!showSideBar && rootUserSideBarRef.current && !rootUserSideBarRef.current.classList.contains('hidden')){
            rootUserSideBarRef.current.classList.add('hidden');
        }
        else if(showSideBar && rootUserSideBarRef.current && rootUserSideBarRef.current.classList.contains('hidden')){
            rootUserSideBarRef.current.classList.remove('hidden');
        }
    },[showSideBar]);
    return (
        <div ref={rootUserSideBarRef} className={`root-user-side-bar ${showSideBar? 'show':''}`}>
            <div className="root-user-side-bar-button-container" onClick={() => navigate('/')}>
                <img src={process.env.PUBLIC_URL + '/images/home-icon.png'} alt="."/>
                <button>Home</button>
            </div>
            <div className="root-user-side-bar-button-container" onClick={() => navigate('/root-user/system-admins')}>
                <img src={process.env.PUBLIC_URL + '/images/system-administrator-icon.png'} alt="."/>
                <button>System administrators</button>
            </div>
        </div>
    );
}
export default RootUserSideBar;